export default function Breadcrumbs({ currentIndex, crumbItems }) {
    return (
        <div className="breadcrumbs-container">
            <a className="breadcrumb-link" href="https://home.arise-biodiversity.nl/">ARISE</a>
            <a className="breadcrumb-link" href="/">Target List</a>
            {Object.keys(crumbItems).map((item, index) => {
                if (currentIndex + crumbItems.length - 1 === index) {
                    return <button className="breadcrumb-link active" id="active-breadcrumb" key={index} onClick={crumbItems[item].action}>{crumbItems[item].text}</button> //href={`?q=${item[1]}&showFrom=${item[0]}`}>{item[1]}</a>;
                } else {
                    return <button className="breadcrumb-link" key={index} onClick={crumbItems[item].action}>{crumbItems[item].text}</button> //href={`?q=${item[1]}&showFrom=${item[0]}`}>{item[1]}</a>;
                }
            })}
        </div>
    )
}